import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AppWithoutFirebase from "./pages/App-without-firebase";
import Index from "./pages/Index";
import Kosovarspage from "./pages/kosovarspage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route path="kosovarspage" element={<Kosovarspage />} />
          <Route path="game">
            <Route path=":id" element={<Home />} />
          </Route>
          <Route path="app-without-firebase" element={<AppWithoutFirebase />} />
          <Route index element={<Index />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
ReactDOM.render(<App />, document.getElementById("root"));

export default App;
